export const QUIZ_YEAR = 2026
